export class Controller {

    /** @ngInject */
    constructor($scope, $state, DirectoriesResource, Alert) {
        this.$scope = $scope;
        this.$state = $state;
        this.DirectoriesResource = DirectoriesResource;
        this.Alert = Alert;
    }

    $onInit() {
    }

    updateAzureDomains() {
        this.DirectoriesResource.updateAzureDomains(
            this.companyId,
            this.directory.id,
        )
        .then((azureDomains) => {
            this.Alert('success', 'company.directory-integration.manage.domains-azure.update-azure-domains-list.updated');
            return this.$state.go('company.directory-integration.manage.domains-azure', {}, {reload: 'company.directory-integration.manage.domains-azure'});
        })
        .catch((error) => {
            this.Alert('danger', error.data.message);
        });
    }

    azureSync() {
        this.DirectoriesResource.azureSync(
            this.companyId,
            this.directory.id,
        )
        .then(() => {
            this.Alert('success', 'company.directory-integration.manage.domains-azure.sync.success');
            return this.$state.go('company.directory-integration.manage.domains-azure', {}, {reload: 'company.directory-integration.manage.domains-azure'});
        })
        .catch((error) => {
            this.Alert('danger', error.data.message);
        });
    }

    azureProvisioning() {
        this.DirectoriesResource.azureProvisioning(
            this.companyId,
            this.directory.id,
        )
        .then(() => {
            this.Alert('success', 'company.directory-integration.manage.domains-azure.provisioning.success');
            return this.$state.go('company.directory-integration.manage.domains-azure', {}, {reload: 'company.directory-integration.manage.domains-azure'});
        })
        .catch((error) => {
            this.Alert('danger', error.data.message);
        });
    }

}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/directory-manage.controller.js